import { YouthAndSportNumber } from '../../lib/types/models/youth-and-sport-number/youth-and-sport-number'
import { YouthAndSportNumberInput } from '../../lib/types/models/youth-and-sport-number/youth-and-sport-number-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createYouthAndSportNumber(data: YouthAndSportNumberInput) {
  return restApiClient
    .url(constructApiUrl(API.youthAndSportNumbers.create.url, null))
    .post<YouthAndSportNumber>(data)
}
